import axiosInstance from "src/common/axiosInstance";
import { dedupedRequest, clearRequestCache } from "src/common/requestCache";

const workspaceService = {
  index(params = {}) {
    const key = `/workspaces?${new URLSearchParams(params).toString()}`;
    return dedupedRequest(key, () =>
      axiosInstance.get("/workspaces", { params }),
    );
  },

  organisationConnections() {
    return axiosInstance.get("/organisation-connections");
  },

  async linkOrganisation(id, organisationId) {
    const response = await axiosInstance.post(
      `/workspaces/${id}/organisation-connection`,
      { organisation_id: organisationId },
    );
    clearRequestCache("/workspaces");
    return response;
  },

  show(id) {
    return axiosInstance.get(`/workspaces/${id}`);
  },

  create(data) {
    clearRequestCache("/workspaces");
    return axiosInstance.post("/workspaces", data);
  },

  update(id, data) {
    clearRequestCache("/workspaces");
    return axiosInstance.put(`/workspaces/${id}`, data);
  },

  destroy(id) {
    clearRequestCache("/workspaces");
    return axiosInstance.delete(`/workspaces/${id}`);
  },
};

export default workspaceService;
